import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import PrintIcon from '@material-ui/icons/PrintOutlined';
import HomeIcon from '@material-ui/icons/AccountCircleOutlined';
import ScrollToTopOnMount from './ScrollToTopOnMount';
import moment from 'moment';
import 'moment/locale/ja';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Logo from "../icons/svg/logo.svg";

moment.locale(); 

const styles = theme => ({
    root: {
      flexGrow: 1,
      display: 'flex',
      padding: '80px 32px',
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
    breadcrumbs: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      marginBottom: '16px',
      ['@media print']: { // eslint-disable-line no-useless-computed-key
        display: 'none',
      }
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: '16px',
    },
    main: {
      width: '100%',
      maxWidth:'800px',
      margin: 'auto',
    },
    rtitle:{
      textAlign: 'center',
      fontSize: '2rem',
      paddingBottom: '3rem'
    },
    rhakko:{
      paddingBottom: '2rem'
    },
    rbtitlerow:{
      height: '4rem'
    },
    detail: {
      width: '100%',
      marginTop: '50px',
    },
    table: {
      minWidth: '100%',
    },
    footer: {
      width: '200px',
      paddingTop: '4rem',
      marginLeft: 'auto'
    }
  });

  class ReceiptPage extends React.Component {
    state = {
      qdata: null,
      qorg: null,
      certificate: null,
      defaultCert: null,
    };
    componentDidMount = async() => {
      const { match:{ params } } = this.props;
      let paidata = null;
      let crsdata = null;

      const paidoc = await this.props.db.collection("userpaid").doc(params.receiptId).get();

      if (paidoc.exists) {
        paidata = paidoc.data();
        if(paidata.item_name.indexOf('????') > -1){
          const crsdoc = await this.props.db.collection("courses").doc(paidata.item_id).get();
          if (crsdoc.exists) {
            crsdata = crsdoc.data();
            paidata.item_name = crsdata.title;
          }
          else{
            paidata.item_name = '-';
          }
        }
      }
      let revision = paidata.revision ? paidata.revision : 1;

      this.setState({
        pdata: {id: paidoc.id, ...paidata},
        cdata: { crsdata },
        revision
      });
  }
    print(){
      const { match:{ params } } = this.props;
      let revision = this.state.revision + 1;
      this.props.db.collection("userpaid").doc(params.receiptId).set({revision}, { merge: true });

      window.print();

      this.setState({
        revision
      });
    }

    render() {
      const { classes } = this.props;
      const { pdata, revision } = this.state;
      return (
        <div >
          <ScrollToTopOnMount/>
          {
            pdata ? 
              <div className={classes.root}>
                  <div className={classes.breadcrumbs}>
                    <Button className={classes.button} size="small" color="primary" component={Link} to="/member/user" ><HomeIcon/>ホーム</Button>{` / `}
                    <Button className={classes.button} size="small" disabled>{`領収書`}</Button>
                  </div>
                  <div className={classes.header}>
                  <div>
                  </div>
                  <IconButton aria-label="印刷" onClick={this.print.bind(this)}>
                    <PrintIcon />
                  </IconButton>
              </div>
              <div className={classes.main}>
                <Typography className={classes.rtitle} variant="subtitle1" clolor="textSecondary">
                    {`領収書`}
                </Typography>
                <div className={classes.rhakko}>
                  <Typography variant="subtitle1">
                    {`発行日：${moment().format('YYYY-MM-DD')}`}
                  </Typography>
                  <Typography variant="subtitle1">
                    {`発行レビジョン：${revision}`}
                  </Typography>
                </div>
                <div className={classes.rbtitle}>
                    <Typography variant="subtitle1">
                      {`下記、正に領収いたしました。`}
                    </Typography>
                </div>
                <div className={classes.detail}>
                  <Table className={classes.table} size="small">
                    <TableBody>
                      <TableRow className={classes.rbtitlerow}>
                        <TableCell>宛名</TableCell>
                        <TableCell>{this.props.user.displayName}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rbtitlerow}>
                        <TableCell>領収金額</TableCell>
                        <TableCell>¥{Number(pdata.amount).toLocaleString()}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rbtitlerow}>
                        <TableCell>支払番号</TableCell>
                        <TableCell>{pdata.order_id}</TableCell>
                      </TableRow>
                      <TableRow className={classes.rbtitlerow}>
                        <TableCell>コース名</TableCell>
                        <TableCell>{pdata.item_name}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
                <div className={classes.footer}>
                  <img
                    src={Logo}
                    className={"Logo"}
                    onClick={this.props.messageHide}
                    alt="ロゴ画像"
                  />
                </div>
              </div>
            </div>: null
          }
        </div>
      );
    }
  }
  
  ReceiptPage.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(ReceiptPage);